import React from "react";
import { Link } from "react-router-dom";
import Fade  from 'react-reveal/Fade';

export default function ServicesCard({ image, text, href }) {
    return (
        <Fade left>
            <Link
                as="a"
                to={href}
            >
                <div className="border_radius_10 mx-4 my-4 w-60 md:w-80 lg:w-96 xl:w-contact_card shadow-card_border h-56 sm:h-80 lg:h-96 xl:h-card_432px">
                    <img src={image} alt={text} />
                    <div className="p-4 sm:p-10">
                        <p className="text-lg sm:text-2xl lg:text-4xl w-40 sm:w-40 lg:w-80">{text}</p>
                    </div>                    
                </div>
            </Link>
        </Fade>
    );
}
